import React from 'react';
import { Button } from '@/components/ui/Button';
import { cn } from '@/lib/utils';

function HashtagSuggestions({ platform, onSelect, className }) {
  // Example hashtag suggestions based on platform
  const suggestions = {
    instagram: [
      '#trending',
      '#viral',
      '#reels',
      '#instagram',
      '#explore',
      '#followme',
      '#instagood',
      '#love'
    ],
    tiktok: [
      '#fyp',
      '#foryou',
      '#viral',
      '#tiktok',
      '#trending',
      '#foryoupage',
      '#comedy',
      '#dance'
    ],
    youtube: [
      '#shorts',
      '#youtube',
      '#viral',
      '#trending',
      '#subscribe',
      '#youtuber',
      '#video',
      '#content'
    ]
  };

  const currentSuggestions = suggestions[platform] || suggestions.instagram;

  return (
    <div className="flex flex-wrap gap-2">
      {currentSuggestions.map((hashtag) => (
        <Button
          key={hashtag}
          variant="outline"
          size="sm"
          onClick={() => onSelect(hashtag)}
          className={cn(
            "bg-white hover:bg-gray-50 text-gray-700 border border-gray-200",
            "hover:border-purple-200 transition-colors duration-200",
            "rounded-lg px-3 py-1.5 text-sm font-medium",
            className
          )}
        >
          {hashtag}
        </Button>
      ))}
    </div>
  );
}

export default HashtagSuggestions; 